import React, { useEffect } from "react";
import "./invoice.css";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Loader from "../layout/Loader";
import { useOrderDetailsQuery } from "../../redux/api/orderApi";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const Invoice = () => {
    const params = useParams();
    const { data, isLoading, error } = useOrderDetailsQuery(params?.id);

    const order = data?.order || {};
    const { shippingInfo, orderItems, paymentInfo, user } = order;

    useEffect(() => {
        if (error) toast.error(error?.data?.message);
    }, [error]);

    const handleDownload = async () => {
        const container = document.getElementById("order_invoice");
        if (!container) return;

        // Apply PDF-friendly styles (fixed width, remove min-widths that cause overflow)
        container.classList.add("invoice-pdf");

        try {
            // Use high DPI scale for crisp mobile output
            const scale = Math.max(2, Math.floor(window.devicePixelRatio || 2));

            // Ensure full content area captured
            const canvas = await html2canvas(container, {
                scale,
                useCORS: true,
                backgroundColor: "#ffffff",
                windowWidth: document.documentElement.scrollWidth,
                windowHeight: document.documentElement.scrollHeight,
            });

            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth(); // ~210mm
            const pdfHeight = pdf.internal.pageSize.getHeight(); // ~297mm

            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * pdfWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            // First page
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
            heightLeft -= pdfHeight;
            position = -pdfHeight;

            // Additional pages if content is taller than one page
            while (heightLeft > 0) {
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
                heightLeft -= pdfHeight;
                position -= pdfHeight;
            }

            pdf.save(`invoice_${order?._id}.pdf`);
        } catch (e) {
            console.error(e);
            toast.error("Failed to generate invoice PDF");
        } finally {
            container.classList.remove("invoice-pdf");
        }
    };

    if (isLoading) return <Loader />;

    return (
        <div className=" my-5" style={{ paddingTop: "80px", paddingBottom: "80px" }}>
            <div className="d-flex justify-content-center mb-4">
                <button className="btn View-btn" onClick={handleDownload}>
                    <i className="fa fa-download me-2"></i> Download Invoice
                </button>
            </div>

            <div id="order_invoice" className=" invoice-container shadow-sm">
                <header className="invoice-header text-center">
                    <h1 className="gradient-text">Trinket of Treasure </h1>
                    <h4 className="invoice-title" >Invoice #{order?._id}</h4>
                    <p className="invoice-date">
                        Date: {new Date(order?.createdAt).toLocaleString("en-US")}
                    </p>
                </header>

                <section className="invoice-details">
                    <div>
                        <h5 className="section-heading" style={{ color: "#e04f6e" }}>Customer Information</h5>
                        <p style={{ color: "#c56f86" }}><b >Name:</b> {user?.name}</p>
                        <p style={{ color: "#c56f86" }}><b>Email:</b> {user?.email}</p>
                        <p style={{ color: "#c56f86" }}><b>Phone:</b> {shippingInfo?.phoneNo}</p>
                        <p style={{ color: "#c56f86" }}>
                            <b>Address:</b> {shippingInfo?.address}, {shippingInfo?.city},{" "}
                            {shippingInfo?.zipCode}, {shippingInfo?.country}
                        </p>
                        <p style={{ color: "#c56f86" }}><b>Payment Status:</b> {paymentInfo?.status}</p>
                    </div>
                </section>

                <main className="invoice-table mt-4">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Item</th>
                                <th>Price</th>
                                <th>Qty</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody >
                            {orderItems?.map((item) => (
                                <tr key={item?.product}>
                                    <td>{item?.product}</td>
                                    <td>{item?.name}</td>
                                    <td>PKR {item?.price}</td>
                                    <td>{item?.quantity}</td>
                                    <td>PKR {item?.price * item?.quantity}</td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan="4" className="text-end fw-bold">
                                    Subtotal
                                </td>
                                <td>PKR {order?.itemsPrice}</td>
                            </tr>
                            {/* <tr>
                                <td colSpan="4" className="text-end fw-bold">
                                    Tax (15%)
                                </td>
                                <td>PKR {order?.taxAmount}</td>
                            </tr> */}
                            <tr>
                                <td colSpan="4" className="text-end fw-bold">
                                    Shipping
                                </td>
                                <td>PKR {order?.shippingAmount}</td>
                            </tr>
                            <tr className="grand-total">
                                <td colSpan="4" className="text-end fw-bold">
                                    Grand Total
                                </td>
                                <td className="fw-bold " style={{ color: "#e91e63" }}>
                                    PKR {order?.totalAmount}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </main>

                <footer className="invoice-footer mt-4">
                    <p className="text mb-1">
                        Invoice generated electronically — no signature required.
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default Invoice;